import React, {Component} from 'react'
import PropTypes from 'prop-types'
import classNames from "classnames"
import showLocationType from "../../../../vietnamese/showLocationType"
import showBasketStatus from "../../../../vietnamese/showBasketStatus"
import ListBasketItems from "./ListBasketItems"
import {Button, message, Select} from 'antd'
import releaseBasket from '../../../merger-v2/actions/releaseBasket'
import * as applyBrandingForAllItems from '../../../../configs/applyBrandingForAllItems'
import ExportQrCode from '../../../merger-v2/actions/ExportQRCode'
import { deleteBasketPosition, updateBasketPosition } from '../../../../services/api/mergerApi'
const { Option } = Select;

class InfoBasket extends Component {
    constructor(props) {
        super(props)
        this.state = {
            submitting: false,
            saving: false,
            deleting: false,
            isEditPosition: false,
            positionEdit: this.props.addedBasket.position ? this.props.addedBasket.position : '',
        }
        this.getDataTimeout = null
    }

    _handleClickRelease = e => {
        e.preventDefault()

        const r = window.confirm('Bạn có chắc chắn muốn xóa giỏ?')
        if (!r) return false

        return this._releaseBasket()
    }

    _releaseBasket = async () => {
        const {submitting} = this.state

        if (submitting) return false

        this.setState({
            submitting: true
        })

        const {_id} = this.props.addedBasket

        try {
            await releaseBasket(_id)
            await deleteBasketPosition(_id)

            message.success('Xóa giỏ thành công!')

            this.setState({
                submitting: false,
                isEditPosition: false,
                positionEdit: ''
            })

            const {onClose} = this.props

            if (typeof onClose === 'function') {
                onClose()
            }
        } catch (e) {
            this.setState({
                submitting: false
            })
            message.error(e.message)
        }
    }

    _handleClickEditPosition = () => {
        // const { addedBasket} = this.props
        // const { position} = { ...addedBasket }

        this.setState({
            isEditPosition: true,
            // positionEdit: position ? position : ''
        })
    }

    _handleCancelEditPosition = () => {
        this.setState({
            isEditPosition: false,
            // positionEdit: ''
        })
    }

    _handleChangePosition = (value) => {
        this.setState({
            positionEdit: value
        })
        clearTimeout(this.getDataTimeout);
        this.getDataTimeout = setTimeout(value ? this._handleAutoSavePositon : this._handleAutoDeletePositon, 1000);
    }

    _handleAutoSavePositon = async() => {
        const {positionEdit} = this.state
        const { addedBasket} = this.props
        const { _id} = { ...addedBasket }
        
        this.setState({
            saving: true
        })

        try{
            const {data}  = await updateBasketPosition(_id, {position: positionEdit})
            const {success, error} = data
            if (success) {
                this.setState({ 
                    saving: false 
                })
                message.success("Update position is success!")
            } else { 
                this.setState({ 
                    saving: false,
                })
                message.error(error) 
            }
        } catch (error) {
            this.setState({ 
                saving: false,
            })
            message.error(error)
        }
        
        this.setState({
            saving: false,
            isEditPosition: false,
            // positionEdit: ''
        })
    }

    _handleAutoDeletePositon = async() => {
        const { addedBasket} = this.props
        const { _id} = { ...addedBasket }
        
        this.setState({
            deleting: true
        })

        try{
            const {data} = await deleteBasketPosition(_id)
            const {success, error} = data
            if(success) {
                this.setState({ 
                    deleting: false 
                })
                message.success("Delete position is success!")
            }else{ 
                this.setState({ 
                    deleting: false 
                })
                message.error(error) 
            }
        } catch (error) {
            this.setState({ 
                deleting: false 
            })
            message.error(error)
        }
        
        this.setState({
            isEditPosition: false,
            positionEdit: ''
        })
    }

    renderTypeBasket = (type = '') => {
        switch(type){
            case 'normal':
                return 'Đơn thường'
            case 'combo_fac':
                return 'Combo FAC'
            case 'combine_ship':
                return 'Gộp ship'
            default:
                return ''
        }
    }

    render() {
        const {isEditPosition, positionEdit, saving, deleting} = this.state
        const { addedBasket, barcode, onClose } = this.props
        const { completed_items, exists, items, number, location, order_number, status, total_items, position, order_numbers = [], type: typeBasket = '' } = { ...addedBasket }
        const vItems = Array.isArray(items) ? items : []
        const action = exists ? 'Đã có giỏ' : 'Giỏ mới'
        const badge = exists ? 'badge-success' : 'badge-info'

        const type = vItems.every(i => i.status === "completed") ? 'primary' : 'secondary'
        const disabled = (vItems.every(i => i.status === "completed"))
        // const checkOneBranding =  vItems.filter(i => ['THANK_CARD', 'BRAND_KIT'].includes(i.product_type)).length === 1
        // const checkOrnamentItem = vItems.filter(i => !['THANK_CARD', 'BRAND_KIT'].includes(i.product_type))
        const checkAllItemStatus = vItems.filter(i => !['THANK_CARD', 'BRAND_KIT'].includes(i.product_type)).every(i => i.status === 'completed')
        
        const haveGIFTBOX_0700NO = !!vItems.filter(i => ['GIFTBOX_0700NO'].includes(i.product_type)).length
        const haveLPRO_ACCESS_00NO = !!vItems.filter(i => ['LPRO_ACCESS_00NO'].includes(i.product_type)).length
        const haveBOX_0700NO = !!vItems.filter(i => ['BOX_0700NO'].includes(i.product_type)).length
        const haveGIFTCARD_1800NO = !!vItems.filter(i => ['GIFTCARD_1800NO'].includes(i.product_type)).length
        const Check_GIFTBOX_0700NO = haveGIFTBOX_0700NO && (vItems.every(i => i.status === "completed"))
        const Check_LPRO_ACCESS_00NO = haveLPRO_ACCESS_00NO && (vItems.every(i => i.status === "completed"))
        const Check_BOX_0700NO = haveBOX_0700NO && (vItems.every(i => i.status === "completed"))
        const Check_GIFTCARD_1800NO = haveGIFTCARD_1800NO && (vItems.filter(i=>!['GIFTCARD_1800NO'].includes(i.product_type)).every(i => i.status === "completed"))

        const optionsPostion = [];
        for (let i = 1; i < 101; i++) {
            optionsPostion.push({
                value: i.toString(),
                label: i.toString(),
            });
        }

        return (
            <div className={classNames("BasketDetail", { exists: !!exists }, status, location)}>
                <div className="Huge">
                    {
                        applyBrandingForAllItems.isSupport(barcode) &&
                        <p className="alert alert-danger mb-4" data-context="MarkQC-InfoBasket">BrandKit theo item</p>
                    }
                    <div className='row mb-3'>
                        <div className='col-4 text-right'>Số giỏ</div>
                        <div className='col-8'>
                            <h4>
                                <span className="BasketNumber">{number}</span>
                                <span className="TotalItems">/{total_items}</span>
                                <span className={classNames("Action ml-5 badge", badge)}>{action}</span>
                            </h4>
                        </div>
                    </div>

                    <div className='row mb-3'>
                        <div className='col-4 text-right'>Hoàn thành</div>
                        <div className='col-8'><h4>{completed_items} / {total_items}</h4></div>
                    </div>

                    <div className='row mb-3'>
                        <div className='col-4 text-right'>Số đơn</div>
                        <div className='col-8'>
                            <h4>
                                {
                                    !!order_numbers.length ?
                                        order_numbers.map(i => `#${i}`).join(', ') :
                                        `#${order_number}`
                                }
                            </h4>
                        </div>
                    </div>

                    <div className='row mb-3'>
                        <div className='col-4 text-right'>Loại đơn</div>
                        <div className='col-8'><h4>{showLocationType(location)}</h4></div>
                    </div>

                    <div className='row mb-3'>
                        <div className='col-4 text-right'>Trạng thái</div>
                        <div className='col-8'>
                            <h4>{showBasketStatus(status)}</h4>
                        </div>
                    </div>
                    {
                        !!typeBasket &&
                        <div className="row mb-3">
                            <div className="col-4 text-right">Loại giỏ</div>
                            <div className="col-8">
                                <h4>{this.renderTypeBasket(typeBasket)}</h4>
                            </div>
                        </div>
                    }
                    <div className='row mb-3'>
                        <div className='col-4 text-right'>Vị trí</div>
                        <div className='col-8 d-flex align-items-center'>
                            {
                                isEditPosition ? <Select
                                showSearch
                                allowClear
                                placeholder=""
                                style={{ width: 70, marginRight: '10px'}}
                                onChange={this._handleChangePosition}
                                value={positionEdit || undefined}
                            >
                                {optionsPostion.map(option => (
                                    <Option key={option.value}>{option.label}</Option>
                                ))}
                            </Select> :
                                <h4 style={{margin: '0 10px 0 0'}}>
                                {
                                    positionEdit ? positionEdit : '--'
                                }
                                </h4>
                            }

                            <Button type="primary" onClick={isEditPosition ? this._handleCancelEditPosition : this._handleClickEditPosition} disabled={saving || deleting ? true : false}>{isEditPosition ? saving ? 'Saving...' : deleting ? 'Deleting...' : 'Cancel' : 'Edit'}</Button>
                        </div>
                    </div>
                    <div className='mb-3'>
                        <div className="ReleaseBasketButton ActionBatches col-12 mb-3 text-center">
                            {(vItems.every(i => i.status === "completed")) &&
                                <Button icon='delete' disabled={!disabled} onClick={this._handleClickRelease} type={type}
                                    size="large">Xóa
                                    giỏ</Button>
                            }
                            {(checkAllItemStatus || Check_GIFTBOX_0700NO || Check_GIFTCARD_1800NO || Check_BOX_0700NO || Check_LPRO_ACCESS_00NO) &&
                                <ExportQrCode
                                    items={items}
                                    basket={number}
                                    totalItems={total_items}
                                    className='ml-3'
                                    reset={onClose}
                                />
                            }
                        </div>
                    </div>
                    <ListBasketItems items={vItems} type={typeBasket}/>
                </div>
            </div>
        )
    }
}

InfoBasket.propTypes = {
    addedBasket: PropTypes.object.isRequired,
}

export default InfoBasket
